import React from 'react'

import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { ReactComponent as RemoveRed } from 'Assets/Icons/RemoveRed.svg'
import { ModalConfirmation } from 'Components/molecules'

const RemoveProductModal = ({ showModal, setShowModal, onAccept }) => {
  const { t } = useTranslation()

  return (
    <ModalConfirmation
      showModal={showModal}
      setShowModal={() => setShowModal(false)}
      onCancel={() => setShowModal(false)}
      onAccept={onAccept}
      color='red'
      title={t('shoppingList.removeProduct.title')}
      action={t('shoppingList.removeProduct.confirm')}
      cancelAction={t('shoppingList.removeProduct.cancel')}
      icon={<RemoveRed />}
    />
  )
}

RemoveProductModal.defaultProps = {
  showModal: false,
  setShowModal: () => null,
  onAccept: () => null,
}

RemoveProductModal.propTypes = {
  showModal: PropTypes.bool,
  setShowModal: PropTypes.func,
  onAccept: PropTypes.func,
}

export default RemoveProductModal
